import { Form, Select } from 'antd';
import { ToggleHeader, ToggleSwitch } from '@/components/toggle-switch';
import VariationTypesForm from '../../VariationTypesForm';
import { useCompanyGeneralDataForm } from '../CompanyGeneralDataFormContext';

/** Bonus, other income, suspension, expenses and non-monetary benefits with variations. */
export default function CompanyBonusFields() {
  const {
    bonusChecked,
    bonusCurrencyKeys,
    bonusCurrencyState,
    bonusKeys,
    bonusState,
    bonusVariationsEnabled,
    bonusVariationsEnabledKeys,
    bonusVariationsEnabledState,
    bonusVariationsTypesKeys,
    currencyOptions,
    form,
    isGrossBonusKeys,
    isGrossBonusState,
    isProfile,
    nonMonetaryBenefitChecked,
    nonMonetaryBenefitCurrencyKeys,
    nonMonetaryBenefitCurrencyState,
    nonMonetaryBenefitKeys,
    nonMonetaryBenefitState,
    nonMonetaryBenefitVariationsEnabled,
    nonMonetaryBenefitVariationsEnabledKeys,
    nonMonetaryBenefitVariationsEnabledState,
    nonMonetaryBenefitVariationsTypesKeys,
    otherExpensesChecked,
    otherExpensesCurrencyKeys,
    otherExpensesCurrencyState,
    otherExpensesKeys,
    otherExpensesState,
    otherIncomeChecked,
    otherIncomeCurrencyKeys,
    otherIncomeCurrencyState,
    otherIncomeKeys,
    otherIncomeState,
    sectionClass,
    suspensionChecked,
    suspensionCurrencyKeys,
    suspensionCurrencyState,
    suspensionKeys,
    suspensionState,
    suspensionVariationsEnabled,
    suspensionVariationsEnabledKeys,
    suspensionVariationsEnabledState,
    suspensionVariationsTypesKeys,
    t,
  } = useCompanyGeneralDataForm();
  // On the profile: laid out by CompanyBonusProfilePanel.
  if (isProfile) return null;

  return (
    <div className={sectionClass('bonus')}>
      {bonusState?.visible && (
        <>
          {!isProfile && <hr className="mb-5" />}

          <ToggleHeader title={t('bonus', { ns: 'forms' })} className="mb-5">
            <ToggleSwitch
              name={bonusKeys}
              form={form}
              disabled={bonusState?.disabled}
            />
          </ToggleHeader>
        </>
      )}

      {isGrossBonusState?.visible && (
        <>
          {!isProfile && <hr className="mb-5" />}

          <ToggleHeader
            title={t('grossBonus', { ns: 'forms' })}
            className="mb-5"
          >
            <ToggleSwitch
              name={isGrossBonusKeys}
              form={form}
              disabled={isGrossBonusState?.disabled}
            />
          </ToggleHeader>
        </>
      )}

      {bonusChecked && bonusCurrencyState?.visible && (
        <Form.Item
          name={bonusCurrencyKeys}
          label={t('bonusCurrency', { ns: 'forms' })}
        >
          <Select
            mode="single"
            placeholder={t('bonusCurrency', { ns: 'forms' })}
            className="w-full"
            loading={false}
            options={currencyOptions}
            disabled={bonusCurrencyState?.disabled}
          />
        </Form.Item>
      )}

      {bonusChecked && bonusVariationsEnabledState?.visible && (
        <>
          <ToggleHeader
            title={t('bonusVariationsEnabled', { ns: 'forms' })}
            className="mb-5"
          >
            <ToggleSwitch
              name={bonusVariationsEnabledKeys}
              form={form}
              disabled={bonusVariationsEnabledState?.disabled}
            />
          </ToggleHeader>

          {bonusVariationsEnabled && (
            <div className="mb-5 rounded-md border bg-zinc-50 p-4">
              <p className="mb-3 font-medium text-gray-700">
                {t('bonusVariations', { ns: 'forms' })}
              </p>
              <VariationTypesForm
                name={bonusVariationsTypesKeys}
                form={form}
                disabled={bonusVariationsEnabledState?.disabled}
                showIncludeInDefault={!bonusVariationsEnabledState?.disabled}
              />
            </div>
          )}
        </>
      )}

      {otherIncomeState?.visible && (
        <>
          {!isProfile && <hr className="mb-5" />}

          <ToggleHeader
            title={t('otherIncomeSalary', { ns: 'forms' })}
            className="mb-5"
          >
            <ToggleSwitch
              name={otherIncomeKeys}
              form={form}
              disabled={otherIncomeState?.disabled}
            />
          </ToggleHeader>
        </>
      )}

      {otherIncomeChecked && otherIncomeCurrencyState?.visible && (
        <Form.Item
          name={otherIncomeCurrencyKeys}
          label={t('otherIncomeCurrency', { ns: 'forms' })}
        >
          <Select
            mode="single"
            placeholder={t('otherIncomeCurrency', { ns: 'forms' })}
            className="w-full"
            loading={false}
            options={currencyOptions}
            disabled={otherIncomeCurrencyState?.disabled}
          />
        </Form.Item>
      )}

      {suspensionState?.visible && (
        <>
          {!isProfile && <hr className="mb-5" />}

          <ToggleHeader
            title={t('suspensionOfEarnings', { ns: 'forms' })}
            className="mb-5"
          >
            <ToggleSwitch
              form={form}
              name={suspensionKeys}
              disabled={suspensionState?.disabled}
            />
          </ToggleHeader>
        </>
      )}

      {suspensionChecked && suspensionCurrencyState?.visible && (
        <Form.Item
          name={suspensionCurrencyKeys}
          label={t('suspensionCurrency', { ns: 'forms' })}
        >
          <Select
            mode="single"
            placeholder={t('suspensionCurrency', { ns: 'forms' })}
            className="w-full"
            loading={false}
            options={currencyOptions}
            disabled={suspensionCurrencyState?.disabled}
          />
        </Form.Item>
      )}

      {suspensionChecked && suspensionVariationsEnabledState?.visible && (
        <>
          <ToggleHeader
            title={t('suspensionVariationsEnabled', { ns: 'forms' })}
            className="mb-5"
          >
            <ToggleSwitch
              name={suspensionVariationsEnabledKeys}
              form={form}
              disabled={suspensionVariationsEnabledState?.disabled}
            />
          </ToggleHeader>

          {suspensionVariationsEnabled && (
            <div className="mb-5 rounded-md border bg-zinc-50 p-4">
              <p className="mb-3 font-medium text-gray-700">
                {t('suspensionVariations', { ns: 'forms' })}
              </p>
              <VariationTypesForm
                name={suspensionVariationsTypesKeys}
                form={form}
                disabled={suspensionVariationsEnabledState?.disabled}
                showIncludeInDefault={
                  !suspensionVariationsEnabledState?.disabled
                }
              />
            </div>
          )}
        </>
      )}

      {otherExpensesState?.visible && (
        <>
          {!isProfile && <hr className="mb-5" />}

          <ToggleHeader
            title={t('otherPaidExpenses', { ns: 'forms' })}
            className="mb-5"
          >
            <ToggleSwitch
              name={otherExpensesKeys}
              form={form}
              disabled={otherExpensesState?.disabled}
            />
          </ToggleHeader>
        </>
      )}

      {otherExpensesChecked && otherExpensesCurrencyState?.visible && (
        <Form.Item
          name={otherExpensesCurrencyKeys}
          label={t('otherExpensesCurrency', { ns: 'forms' })}
        >
          <Select
            mode="single"
            placeholder={t('otherExpensesCurrency', { ns: 'forms' })}
            className="w-full"
            loading={false}
            options={currencyOptions}
            disabled={otherExpensesCurrencyState?.disabled}
          />
        </Form.Item>
      )}

      {nonMonetaryBenefitState?.visible && (
        <>
          {!isProfile && <hr className="mb-5" />}

          <ToggleHeader
            title={t('nonMonetaryBenefit', { ns: 'forms' })}
            className="mb-5"
          >
            <ToggleSwitch
              name={nonMonetaryBenefitKeys}
              form={form}
              disabled={nonMonetaryBenefitState?.disabled}
            />
          </ToggleHeader>
        </>
      )}

      {nonMonetaryBenefitChecked &&
        nonMonetaryBenefitCurrencyState?.visible && (
          <Form.Item
            name={nonMonetaryBenefitCurrencyKeys}
            label={t('nonMonetaryBenefitCurrency', { ns: 'forms' })}
          >
            <Select
              mode="single"
              placeholder={t('nonMonetaryBenefitCurrency', { ns: 'forms' })}
              className="w-full"
              loading={false}
              options={currencyOptions}
              disabled={nonMonetaryBenefitCurrencyState?.disabled}
            />
          </Form.Item>
        )}

      {nonMonetaryBenefitChecked &&
        nonMonetaryBenefitVariationsEnabledState?.visible && (
          <>
            <ToggleHeader
              title={t('nonMonetaryBenefitVariationsEnabled', {
                ns: 'forms',
              })}
              className="mb-5"
            >
              <ToggleSwitch
                name={nonMonetaryBenefitVariationsEnabledKeys}
                form={form}
                disabled={nonMonetaryBenefitVariationsEnabledState?.disabled}
              />
            </ToggleHeader>

            {nonMonetaryBenefitVariationsEnabled && (
              <div className="mb-5 rounded-md border bg-zinc-50 p-4">
                <p className="mb-3 font-medium text-gray-700">
                  {t('nonMonetaryBenefitVariations', { ns: 'forms' })}
                </p>
                <VariationTypesForm
                  name={nonMonetaryBenefitVariationsTypesKeys}
                  form={form}
                  disabled={nonMonetaryBenefitVariationsEnabledState?.disabled}
                  showIncludeInDefault={
                    !nonMonetaryBenefitVariationsEnabledState?.disabled
                  }
                />
              </div>
            )}
          </>
        )}
    </div>
  );
}
